export default "__VITE_ASSET__BXot2ZGQ__"